import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import PackagesContainer from 'connect/core/controls/packages';
import EConnectSectionsMode from 'connect/settings/desktop/controls/sections/connect-sections-mode';
import type HistoryStore from 'connect/web/src/stores/history-store';
import type SearchStore from 'connect/web/src/stores/search-store';
import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment, { Moment } from 'moment';
import * as React from 'react';
import type { PackageResponse } from 'tm3-core/api.dtos';
import Dashboard from '../dashboard';
import Sections from '../dashboard/controls/sections';
import styles from './styles';

interface IProps extends WithStyles<typeof styles> {
  historyStore?: HistoryStore;
  searchStore?: SearchStore;
}

@inject('historyStore', 'searchStore')
@observer
class ExplorePackages extends React.Component<IProps> {
  render() {
    const { classes, searchStore } = this.props;

    if (searchStore!.loading) {
      return <CircularProgress />;
    }

    if (this.packages.length === 0) {
      return (
        <div className={`${classes.noPackagesAvailable} container`}>
          There are no packages currently available
        </div>
      );
    }

    if (this.customisedPackages) {
      return <Sections mode={EConnectSectionsMode.PackagesSections} />;
    }

    return (
      <div className={`container ${classes.base}`}>
        <h2 className={classes.header}>Explore and purchase great value tailored packages</h2>
        <PackagesContainer
          packages={this.packages}
          onSelectPackage={this.onClick}
          isDashboard={true}
        />
      </div>
    );
  }

  @computed
  get customisedPackages(): Boolean {
    const { sections } = this.props.searchStore!;
    return sections.some((x) => x.mode == EConnectSectionsMode.PackagesSections);
  }

  @computed
  get packages(): PackageResponse[] {
    const { packages } = this.props.searchStore!;
    return packages.filter((pack: PackageResponse) => pack.online);
  }
  @action.bound
  onClick(packageId: string) {
    const { packages } = this.props.searchStore;
    const { historyStore } = this.props;

    const selectedPackage = packages.find((p) => p.onlineGuid === packageId);
    historyStore!.push('/packages/' + encodeURI(selectedPackage!.urlSlug));
  }
}

export default withStyles(styles)(ExplorePackages);
